<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" label-width="120px" :model="form" class="demo-form-inline ">
        <el-form-item label="客户名称" prop="custId">
          <el-select v-model="form.custId"  clearable filterable placeholder="请选择客户名称">
            <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in form.cusData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户名称" prop="accountName">
          <el-input style="width: 217px;"  maxlength="30" placeholder="请输入账户名称" clearable v-model="form.accountName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="账户编号"  prop="accountId">
          <el-input style="width: 217px;"  maxlength="30" placeholder="请输入账户编号" clearable v-model="form.accountId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="账户状态" prop="state">
          <el-select v-model="form.state" clearable filterable placeholder="请选择账户状态">
            <el-option label="启用" value="1" ></el-option>
            <el-option label="停用" value="0" ></el-option>
            <el-option label="测试" value="2" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值日期" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="addAccount" icon="el-icon-plus"></el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="客户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.custAccountName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户编号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custAccountId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户密码"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custAccountPwd }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="api Key"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.apiKey }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户状态"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.state === '0' ? '停用' : '启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户余额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.balance }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预警阈值(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.threshold }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="授信额度"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.creditLine }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建人"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.creator }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" :disabled="(scope.row.state === '0' ? true : false)" @click="recharge(scope.$index, scope.row)">充值</el-button>
            <el-switch
              v-model="scope.row.state"
              :active-value="on"
              :inactive-value="off"
              @change="change(scope.$index, scope.row)" >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog @close="closeAccount" :title="accountTitle" width="450px" center :modal-append-to-body='false' :visible.sync="accountDialog">
      <el-form :model="accountInfo" :rules="accountRule" ref="accountInfo">
          <el-form-item label="客户名称:" prop="custId" :required="required"  :label-width="formLabelWidth">
            <el-select v-if="!supDisabled" :disabled="supDisabled" v-model="accountInfo.custId" clearable filterable  placeholder="请选择客户名称">
              <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in form.cusData" :key="$index" ></el-option>
            </el-select>
            <el-input style="width: 217px;" v-if="supDisabled" :disabled="supDisabled" maxlength="30" clearable v-model="accountInfo.custName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户名称:" prop="accountName"  :required="required" :label-width="formLabelWidth">
            <el-input style="width: 217px;"  maxlength="30" clearable v-model="accountInfo.accountName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户密码:" prop="password" :label-width="formLabelWidth">
            <el-input style="width: 217px;"  maxlength="30" clearable v-model="accountInfo.password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="apiKey:" prop="apiKey" :required="required" :label-width="formLabelWidth">
            <el-input style="width: 217px;"  maxlength="30" placeholder="请输入apiKey" clearable v-model="accountInfo.apiKey" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户状态:" prop="state"  :label-width="formLabelWidth" :required="required">
            <el-select  clearable  v-model="accountInfo.state" filterable  placeholder="请选择账户状态">
              <el-option label="启用" value="1" ></el-option>
              <el-option label="停用" value="0" ></el-option>
              <el-option label="测试" value="2" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="余额设置:"  prop="banlance"  :required="required" :label-width="formLabelWidth">
            <el-input style="width: 217px;" :disabled="supDisabled"  maxlength="30" clearable v-model="accountInfo.banlance" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="预警阈值:"  prop="threshold"  :required="required" :label-width="formLabelWidth">
            <el-input style="width: 217px;"  maxlength="30" clearable v-model="accountInfo.threshold" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="授信额度(元)"
            :required="required" :label-width="formLabelWidth"
            prop="credit"
          >
            <el-input
              v-model="accountInfo.credit"
              style="width: 217px;"
              placeholder="请输入授信额度"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item style="textAlign: center;">
            <el-button @click="accountDialog=false">取 消</el-button>
            <el-button type="primary" v-show="add" @click="addSave('accountInfo')">确 定</el-button>
            <el-button type="primary" v-show="!add" @click="editSave('accountInfo')">确 定</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog  title="客户账户详情"  width="450px" center :modal-append-to-body='false' :visible.sync="accountDetailDialog">
      <el-form :model="accountDetailInfo" >
          <el-form-item label="客户名称:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.custName" ></el-input>
            <!-- <span>{{accountDetailInfo.custName}}</span> -->
          </el-form-item>
          <el-form-item label="账户名称:"  :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.accountName" ></el-input>
            <!-- <span>{{accountDetailInfo.accountName}}</span> -->
          </el-form-item>
          <el-form-item label="账户密码:"  :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.password" ></el-input>
            <!-- <span>{{accountDetailInfo.password}}</span> -->
          </el-form-item>
          <el-form-item label="apiKey:" :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.apiKey" ></el-input>
            <!-- <span>{{accountDetailInfo.apiKey}}</span> -->
          </el-form-item>
          <el-form-item label="账户状态:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.state" ></el-input>
            <!-- <span>{{accountDetailInfo.state}}</span> -->
          </el-form-item>
          <el-form-item label="余额设置:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.banlance" ></el-input>
            <!-- <span>{{accountDetailInfo.banlance}}</span> -->
          </el-form-item>
          <el-form-item label="授信额度:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="accountDetailInfo.credit" ></el-input>
            <!-- <span>{{accountDetailInfo.banlance}}</span> -->
          </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog @close="closeRecharge" title="充值" width="750px"  center :modal-append-to-body='false' :visible.sync="rechargeDialog">
      <el-form :model="rechargeInfo" :rules="rechargeRule" ref="rechargeInfo">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称:" :required="required"  :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.custName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="账户名称:"   :required="required" :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="rechargeInfo.accountName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="账户余额:"  :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="rechargeInfo.balance" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="充值账户:"  :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.rechargeAccount" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="充值金额:" prop="rechargeAmount" :required="required" :label-width="formLabelWidth">
              <el-input style="width: 217px;"  maxlength="30" placeholder="请输入充值金额" clearable v-model="rechargeInfo.rechargeAmount" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item ref="urlRule" label="充值凭证:"  prop="dialogImageUrl"  :required="required" :label-width="formLabelWidth">
              <el-upload
                :action="action"
                list-type="picture-card"
                :limit="num"
                ref='upload'
                :headers="headers"
                :before-upload="beforeAvatarUpload"
                :on-exceed="exceed"
                :on-success="success"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.GIF,.BMP"
                :on-remove="handleRemove"
                :on-preview="handlePictureCardPreview">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog center :modal-append-to-body='false' :visible.sync="dialogVisible">
                <img width="100%" :src="rechargeInfo.dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否包年:" prop="yearFlag" :required="required" :label-width="formLabelWidth">
              <el-select  clearable  v-model="rechargeInfo.yearFlag" filterable  placeholder="请选择是否包年">
                <el-option label="否" value="0" ></el-option>
                <el-option label="是" value="1" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充值类型:" prop="rechargeType" :required="required" :label-width="formLabelWidth">
              <el-select  clearable  v-model="rechargeInfo.rechargeType" filterable  placeholder="请选择充值类型">
                <el-option label="预充值" value="0" ></el-option>
                <el-option label="补偿款" value="1" ></el-option>
                <el-option label="扣减" value="2" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式:" prop="payMethod" :required="required"  :label-width="formLabelWidth">
              <el-select  clearable  v-model="rechargeInfo.payMethod" filterable  placeholder="请选择支付方式">
                <el-option label="垫付" value="0" ></el-option>
                <el-option label="网银转账" value="1" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充值说明:"    :label-width="formLabelWidth">
              <el-input type="textarea" style="width: 217px;" maxlength="150" placeholder="打款说明" v-model="rechargeInfo.desc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="textAlign: center;">
          <el-button @click="rechargeDialog=false">取 消</el-button>
          <el-button type="primary"  @click="rechargeSave('rechargeInfo')">充 值</el-button>
        </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'customerAccount',
  data () {
    return {
      form: {
        custId: '',
        cusData: [],
        accountId: '',
        accountName: '',
        state: '',
        date: ''
      },
      tooltip: true,
      num: 1,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      accountTitle: '',
      modalClick: false,
      accountDialog: false,
      rechargeDialog: false,
      accountDetailDialog: false,
      editable: false,
      add: false,
      required: true,
      supDisabled: false,
      action: this.$API.fileUpload,
      dialogVisible: false,
      dialogImageUrl: '',
      formLabelWidth: '120px',
      rechargeInfo: {
        custName: '',
        accountName: '',
        balance: '',
        rechargeAccount: '',
        rechargeAmount: '',
        yearFlag: '',
        rechargeType: '',
        payMethod: '',
        desc: '',
        dialogImageUrl: ''
      },
      accountInfo: {
        banlance: '',
        credit: 5000000,
        state: '',
        apiKey: '',
        password: '',
        accountName: '',
        custId: '',
        custName: '',
        threshold: ''
      },
      accountDetailInfo: {
        banlance: '',
        state: '',
        apiKey: '',
        credit: '',
        password: '',
        accountName: '',
        custId: '',
        custName: ''
      },
      custAccountId: '', // 账户id
      accountRule: {
        custId: [
          { required: true, message: '请选择客户名称', trigger: 'change' }
        ],
        state: [
          { required: true, message: '请选择账户状态', trigger: 'change' }
        ],
        accountName: [
          { required: true, message: '请输入账户名称', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        password: [{
          validator: (rule, value, callback) => {
            if (value !== '') {
              if ((/^[a-zA-Z0-9_]{1,}$/).test(value) === false) {
                callback(new Error('请填写数字字母下划线'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          },
          trigger: 'change',
          required: false
        }],
        apiKey: [
          { required: true, message: '请输入apiKey', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        credit: [
          { required: true, message: '请输入授信额度', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        banlance: [{
          validator: (rule, value, callback) => {
            if (value !== '') {
              if ((/[^\-?\d.]/).test(value) === true) {
                callback(new Error('请输入正确的数字'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请填写数字'))
            }
          },
          trigger: ['blur', 'change'],
          required: true
        }],
        threshold: [{
          validator: (rule, value, callback) => {
            if (value !== '') {
              if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                callback(new Error('请填写大于0的数字'))
              } else if ((/^[0-9]+(.[0-9]{1,2})?$/).test(value) === false) {
                callback(new Error('请输入有效金额且小数点后面保留两位'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请填写大于0的数字'))
            }
          },
          trigger: ['blur', 'change'],
          required: true
        }]
      },
      rechargeRule: {
        yearFlag: [
          { required: true, message: '请选择是否包年', trigger: 'change' }
        ],
        rechargeType: [
          { required: true, message: '请选择充值类型', trigger: 'change' }
        ],
        payMethod: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        rechargeAmount: [{
          validator: (rule, value, callback) => {
            let reg = /^(-)?\d+(\.\d{1,2})?$/
            if (value !== '') {
              if (reg.test(value) === false) {
                callback(new Error('请填写正确数字'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请填写正确数字'))
            }
          },
          trigger: ['blur', 'change'],
          required: true
        }],
        dialogImageUrl: [
          { required: true, message: '支付凭证不能为空', trigger: ['blur', 'change'] }
        ]
      },
      on: '1',
      off: '0',
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    rechargeSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.custAccountId = _this.rechargeInfo.rechargeAccount
          op.rechargeAmount = _this.rechargeInfo.rechargeAmount
          op.yearFlag = _this.rechargeInfo.yearFlag
          op.rechargeType = _this.rechargeInfo.rechargeType
          op.payMethod = _this.rechargeInfo.payMethod
          op.rechargeUrl = _this.rechargeInfo.dialogImageUrl
          op.rechargeDesc = _this.rechargeInfo.desc
          if (_this.rechargeInfo.rechargeType === '2') {
            if (_this.rechargeInfo.rechargeAmount >= 0 || Number(_this.rechargeInfo.rechargeAmount) + Number(_this.balance) < 0) {
              _this.$message.error('充值类型为扣减时, 账户余额和充值金额之和必须大于等于0, 且充值金额必须小于0!')
              return
            }
          }
          if (_this.rechargeInfo.rechargeAmount < 0 && _this.rechargeInfo.rechargeType !== '2') {
            _this.$message.error('充值金额小于0时,充值类型必须为扣减!')
            return
          }
          _this.$axios({
            url: _this.$API.accountManagement.custAccountRecharge,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('客户账户充值成功!')
            _this.rechargeDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    detail (index, row) {
      this.accountDetailInfo.custName = row.custName
      this.accountDetailInfo.accountName = row.custAccountName
      this.accountDetailInfo.password = row.custAccountPwd
      this.accountDetailInfo.credit = row.creditLine
      this.accountDetailInfo.apiKey = row.apiKey
      this.accountDetailInfo.banlance = row.balance
      if (row.state === '1') {
        this.accountDetailInfo.state = '启用'
      } else if (row.state === '0') {
        this.accountDetailInfo.state = '停用'
      } else {
        this.accountDetailInfo.state = '测试'
      }
      this.accountDetailDialog = true
    },
    handleRemove (file, fileList) {
      this.rechargeInfo.dialogImageUrl = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    success (response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        this.rechargeInfo.dialogImageUrl = response.resData.url
        this.$refs['urlRule'].clearValidate()
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG.match(/.jpg|.jpeg|png/i)) {
        this.$message.error('上传图片只能是 jpg或jpeg或png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    exceed (files, fileList) {
      this.$message.error('一次只能上传一张凭证, 且删除后才能重新上传新的凭证')
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.custId = ''
      this.form.accountName = ''
      this.form.state = ''
      this.form.date = ''
      this.form.accountId = ''
    },
    recharge (index, row) { // 充值
      this.rechargeInfo.custName = row.custName
      this.rechargeInfo.accountName = row.custAccountName
      this.rechargeInfo.balance = row.balance
      this.rechargeInfo.rechargeAccount = row.custAccountId
      this.rechargeDialog = true
    },
    closeRecharge () {
      this.rechargeInfo = {
        custName: '',
        accountName: '',
        balance: '',
        rechargeAccount: '',
        rechargeAmount: '',
        yearFlag: '',
        rechargeType: '',
        payMethod: '',
        desc: '',
        dialogImageUrl: ''
      }
      this.$refs.upload.clearFiles()
      console.log('ss')
      this.$refs['rechargeInfo'].resetFields() // 关闭时清除验证条件
      this.rechargeDialog = false
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    closeAccount () {
      this.accountInfo = {
        banlance: '',
        state: '',
        apiKey: '',
        credit: 5000000,
        password: '',
        accountName: '',
        custId: '',
        threshold: '',
        custName: ''
      }
      this.$refs['accountInfo'].resetFields() // 关闭时清除验证条件
      this.accountDialog = false
    },
    addAccount () { // 新增账户
      this.accountTitle = '新增账户'
      this.add = true
      this.supDisabled = false
      this.accountDialog = true
    },
    handleEdit (index, row) { // 编辑账户
      console.log(row)
      this.accountTitle = '编辑账户'
      this.add = false
      this.supDisabled = true
      this.custAccountId = row.custAccountId
      this.accountInfo.banlance = row.balance
      this.accountInfo.state = row.state
      this.accountInfo.credit = row.creditLine
      this.accountInfo.apiKey = row.apiKey
      this.accountInfo.password = row.custAccountPwd
      this.accountInfo.accountName = row.custAccountName
      this.accountInfo.custId = row.custId
      this.accountInfo.custName = row.custName
      this.accountInfo.threshold = row.threshold
      this.accountDialog = true
    },
    editSave (formName) { // 编辑保存
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.custId = _this.accountInfo.custId
          op.custAccountName = _this.accountInfo.accountName
          op.custAccountPwd = _this.accountInfo.password
          op.creditLine = _this.accountInfo.credit
          op.state = _this.accountInfo.state
          op.balance = _this.accountInfo.banlance
          op.custAccountId = _this.custAccountId
          op.apiKey = _this.accountInfo.apiKey
          op.threshold = _this.accountInfo.threshold
          // if (op.balance < op.threshold) {
          //   _this.$message.error('账户余额必须大于预警阈值!')
          //   return
          // }
          _this.$axios({
            url: _this.$API.accountManagement.updateCustAccount,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('客户账户更新成功!')
            _this.accountDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    addSave (formName) { // 新增保存
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.custId = _this.accountInfo.custId
          op.custAccountName = _this.accountInfo.accountName
          op.custAccountPwd = _this.accountInfo.password
          op.state = _this.accountInfo.state
          op.balance = _this.accountInfo.banlance
          op.creditLine = _this.accountInfo.credit
          op.apiKey = _this.accountInfo.apiKey
          op.threshold = _this.accountInfo.threshold
          // if (op.balance < op.threshold) {
          //   _this.$message.error('账户余额必须大于预警阈值!')
          //   return
          // }
          _this.$axios({
            url: _this.$API.accountManagement.addCustAccount,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('客户账户新增成功!')
            _this.accountDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    change (index, value) {
      let op = {}
      op.custAccountId = value.custAccountId
      let _this = this
      console.log(value.state)
      if (value.state === '1') {
        value.state = '0'
        op.state = '1'
        this.$confirm('确认是否修改账户状态为启用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            method: 'post',
            url: _this.$API.accountManagement.updateCusAccStatusById,
            data: op
          }).then((response) => {
            if (response.data.resCode === 1) {
              _this.$message.success('账户启用成功!')
              _this.query()
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        value.state = '1'
        op.state = '0'
        this.$confirm('确认是否修改账户状态为停用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            method: 'post',
            url: _this.$API.accountManagement.updateCusAccStatusById,
            data: op
          }).then((response) => {
            if (response.data.resCode === 1) {
              _this.$message.success('账户停用成功!')
              _this.query()
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    initData () {
      let _this = this
      this.$axios({
        url: _this.$API.rechargeManagement.queryCustSimpleInfoList,
        method: 'post',
        data: {}
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.cusData = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.custAccountId = this.form.accountId
      op.custAccountName = this.form.accountName
      op.custId = this.form.custId
      op.state = this.form.state
      op.startTime = this.form.date ? this.form.date[0] : ''
      op.endTime = this.form.date ? this.form.date[1] : ''
      this.$axios({
        url: _this.$API.accountManagement.queryCustAccountListByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/accountManagement/customerAccount.vue